import React, { useState } from "react";
import { Container, Logo } from "./styles";
import { MenuOutlined } from "@ant-design/icons";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";
import userPhoto from "../../images/user.png";
import logo from "../../images/logo.png";
import { Button, Drawer } from "antd";
import Menu from "../Menu";
import { MdArrowBack, MdClose } from "react-icons/md";

const Header = ({ sidebar }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  return (
    <Container>
      {sidebar && (
        <>
          <Button
            className="menu"
            type="primary"
            style={{ paddingBottom: 0 }}
            icon={<MenuOutlined />}
            onClick={() => setVisible(true)}
          />
          <Drawer
            title="Menu"
            placement="left"
            closeIcon={<MdClose color="#FFF" size={25} />}
            width={250}
            onClick={() => setVisible(false)}
            onClose={() => setVisible(false)}
            styles={{
              body: {
                background: "#008037",
                padding: 0,
              },
              header: {
                padding: "12px 10px",
                background: "#008037",
                color: "#FFF",
                fill: "#FFF",
              },
            }}
            open={visible}
          >
            <Menu />
          </Drawer>
        </>
      )}

      <Logo sidebar={sidebar}>
        <img src={logo} alt="" />
      </Logo>

      {user && (
        <div>
          {sidebar ? (
            <p className="info">
              Seja bem-vindo, {user.name?.split(" ")[0] || ""}
            </p>
          ) : (
            <Button
              type="primary"
              onClick={() => {
                navigate(-1);
              }}
              style={{
                borderRadius: 50,
                height: 30,
                fontSize: 13,
                alignSelf: "center",
                marginRight: 25,
              }}
            >
              Voltar para a Página Anterior
            </Button>
          )}
          <button
            onClick={() => {
              navigate(`/${user.type}/perfil`);
            }}
          >
            <img src={user.photo ? user.photo_url : userPhoto} />
          </button>
        </div>
      )}
    </Container>
  );
};

export default Header;
